export const Subtract = `<svg title="Subtract" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.9999 13V11L3.99988 11V13L19.9999 13Z" fill="currentcolor"/>
</svg>`;